import { Tabs, TabsProps } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

// services
import { isRTL } from 'core/services/language';

// components
import UploadDocumentComponent from '../components/uploadDocuments';
import ReviewDocumentComponent from '../components/reviewDocuments';
import PageTitle from 'components/title/title';
import { useSelector } from 'react-redux';
import { RootState } from 'stores/store';

const CompanyDocumentsPage: FunctionComponent = () => {
	const { t } = useTranslation();

	const company = useSelector((state: RootState) => state.company);

	let tabItems: TabsProps['items'] = [
		{
			key: 'review',
			label: t('DOCUMENTS.DOCUMENTS_REVIEW'),
			destroyInactiveTabPane: true,
			children: <ReviewDocumentComponent />,
		},
	];

	if (
		company?.registration_step === 'document_downloads' ||
		(company?.profile_status === 'FieldUpdateRequest' && company?.field_update_request)
	) {
		tabItems.unshift({
			key: 'upload',
			label: t('DOCUMENTS.UPLOAD_DOCUMENTS'),
			destroyInactiveTabPane: true,
			children: <UploadDocumentComponent />,
		});
	}

	return (
		<>
			<PageTitle
				name={
					company?.profile_status! == 'FieldUpdateRequest'
						? t('SIDEBAR.UPDATE_COMPANY_DOCUMENTS')
						: company?.has_documents
						? t('SIDEBAR.VIEW_COMPANY_DOCUMENTS')
						: t('SIDEBAR.ADD_COMPANY_DOCUMENTS')
				}
			/>

			<Tabs defaultActiveKey="1" items={tabItems} size="large" direction={isRTL() ? 'rtl' : 'ltr'} />
		</>
	);
};

export default CompanyDocumentsPage;
